/* One complimentary box per qualifying cart. No requests until configured. */
(function () {
  'use strict';
  if (window.ElAvionGiftBox) return;
  const node = document.getElementById('ElAvionGiftBoxConfig');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  if (!config.enabled || !config.variantId || !config.productId || !config.handle) return;
  const root = (window.Shopify && Shopify.routes.root) || '/';
  const seasoning = new Set((config.seasoningIds || []).map(String));
  const paprika = new Set((config.paprikaIds || []).map(String));
  let pending = null;
  async function request(path, data) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(root + path, {
        method: data ? 'POST' : 'GET', credentials: 'same-origin',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/json' },
        ...(data ? { body: JSON.stringify(data) } : { cache: 'no-store' })
      });
      if (!response.ok) throw new Error('Gift box request failed: ' + response.status);
      return await response.json();
    } finally {
      clearTimeout(timeout);
    }
  }
  function qualifies(items) {
    let s = 0, p = 0;
    for (const item of items) {
      if (String(item.product_id) === String(config.productId)) continue;
      if (seasoning.has(String(item.product_id))) s += item.quantity;
      if (paprika.has(String(item.product_id))) p += item.quantity;
    }
    return s >= 4 || p >= 3;
  }
  async function normalize(cart) {
    const eligible = qualifies(cart.items);
    const boxes = cart.items.filter(item => String(item.product_id) === String(config.productId));
    const updates = {};
    let retained = false;
    for (const item of boxes) {
      const keep = eligible && !retained && String(item.variant_id) === String(config.variantId) && item.final_price === 0;
      const quantity = keep ? 1 : 0;
      if (keep) retained = true;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    return Object.keys(updates).length ? request('cart/update.js', { updates }) : cart;
  }
  async function reconcile() {
    let cart = await normalize(await request('cart.js'));
    const eligible = qualifies(cart.items);
    const retained = cart.items.some(item => String(item.product_id) === String(config.productId));
    if (eligible && !retained) {
      // Recheck availability and live price; never silently add a paid gift.
      const product = await request('products/' + encodeURIComponent(config.handle) + '.js');
      const variant = product.variants.find(v => String(v.id) === String(config.variantId));
      if (!variant || !variant.available || variant.price !== 0) throw new Error('Gift box unavailable or not free');
      await request('cart/add.js', { items: [{ id: config.variantId, quantity: 1, properties: { _el_avion_gift: '4-seasonings-or-3-paprikas' } }] });
      cart = await normalize(await request('cart.js'));
    }
    // Verify the server result too: price or qualifying quantities can change in flight.
    const finalBoxes = cart.items.filter(item => String(item.product_id) === String(config.productId));
    const validBox = finalBoxes.length === 1 && finalBoxes[0].quantity === 1 &&
      String(finalBoxes[0].variant_id) === String(config.variantId) && finalBoxes[0].final_price === 0;
    if (qualifies(cart.items) ? !validBox : finalBoxes.length !== 0) {
      throw new Error('Gift box cart verification failed');
    }
    document.querySelectorAll('[data-gift-box-status]').forEach(el => {
      el.textContent = '';
      el.hidden = true;
    });
    return cart;
  }
  function sync(fresh = false) {
    // Cart mutations must wait for a fresh read after any older reconciliation.
    if (fresh && pending) return pending.then(() => sync(true));
    // Shared promise prevents duplicate gifts from simultaneous drawer refreshes.
    if (!pending) pending = reconcile().finally(() => { pending = null; });
    return pending;
  }
  function report() {
    document.querySelectorAll('[data-gift-box-status]').forEach(el => {
      el.textContent = config.error;
      el.hidden = false;
    });
  }
  window.ElAvionGiftBox = { sync, qualifies, report };
  document.addEventListener('DOMContentLoaded', () => {
    sync().then(() => document.dispatchEvent(new CustomEvent('cart:build'))).catch(report);
  }, { once: true });
})();
